/**
 * AR Vision Demo — side-effect mount (no visible UI).
 *
 * THROWAWAY DEMO CODE. While demo mode is on, registers the AR demo's cross-page
 * navigation, technical-demo, portal, and voice-call tools so scripted beats can
 * fire from any page. The visible reset/exit affordance now lives in the global
 * Cmd+K demo command and the avatar ring in the sidebar, so this renders
 * nothing. Mounted once in the authenticated layout; a clean deletion boundary.
 */

import { isArDemoMode } from './demo-mode';
import { registerVoiceCallTools } from './registerVoiceCallTools';
import { useArDemoGlobalNavTools } from './useArDemoGlobalNavTools';
// AR Technical Demo (F0 / GEN-2256) — register checkpoint + nav tools.
import { useTechnicalDemoTools } from './registerTechnicalDemoTools';
// AR Technical Demo (F3 / GEN-2259) — register Crestline portal action tools.
import { usePortalDemoTools } from './registerPortalTools';

export function ArDemoControls() {
  // Register cross-page demo navigation tools up-front (before any early return,
  // per the Rules of Hooks) so scripted beats can fire them from any page.
  useArDemoGlobalNavTools();

  // AR Technical Demo (F0 / GEN-2256) — register the Crestline-storyline
  // checkpoint + navigation tools up-front so the technical-demo beats resolve
  // and stand up their scene state from any page (non-linear entry, §2b).
  useTechnicalDemoTools();

  // AR Technical Demo (F3 / GEN-2259) — register the Crestline vendor-portal
  // action tools (pull backups / file claim) up-front so the portal beats
  // resolve from any page.
  usePortalDemoTools();

  // AR Vision Demo (GEN-2254) — eagerly register the Scene 7/8 voice-call tools
  // so they resolve even if the prompt is typed before the overdue customer's
  // profile has mounted. The page-mounted ArOverdueCustomerDemo upgrades these
  // to the live-Vapi + router-navigation versions when active.
  if (isArDemoMode()) {
    registerVoiceCallTools();
  }

  return null;
}
